import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const ProductionInput = lazy(() => import("../../pages/production_management/ProductionInput"))
const Oee = lazy(() => import("../../pages/production_management/Oee"))
const ProductList = lazy(() => import("../../pages/production_management/product/ProductList"))
const AddProduct = lazy(() => import("../../pages/production_management/product/AddProduct"))
const UpdateProduct = lazy(() => import("../../pages/production_management/product/UpdateProduct"))

export const ProductionRouteImport = {
    RoutesMap,
    ProductionInput,
    Oee,
    ProductList,
    AddProduct,
    UpdateProduct,
}
